module.exports = __webpack_public_path__ + "img/weddings_03_V.21c88c3e.webp";